<template>
    <ul class="list-group">
        <li class="list-group-item p-75" >
            <label class="form-label text-secondary">Anlaşma Sağlandı Mı?</label>
            <div>
                <b-form-radio inline v-model="value.Agreed" :value="true">Evet</b-form-radio>
                <b-form-radio inline v-model="value.Agreed" :value="false">Hayır</b-form-radio>
            </div>
        </li>
        <li class="list-group-item p-75" v-if="value.Agreed == true">
            <div class="row">
                <div class="col-md-6">
                    <label class="form-label text-secondary">Ödeme Tarihi</label>
                    <v-date-picker placeholder="Ödeme Tarihi" v-model="value.PaymentDeadline"></v-date-picker>
                </div>
                <div class="col-md-6">
                    <label class="form-label text-secondary">Ödeme Miktarı</label>
                    <input type="number" class="form-control" v-model="value.PaymentAmount" placeholder="Ödeme Miktarı"/>
                </div>
            </div>
        </li>
        <li class="list-group-item p-75" v-else-if="value.Agreed == false">
            <label class="form-label text-secondary">Anlaşma Sağlanamama Nedeni</label>
            <textarea class="form-control resize-none" v-model="value.Description" placeholder="Anlaşma Sağlanamama Nedeni" rows="4"></textarea>
        </li>
    </ul>
</template>

<script>
import { BFormRadio } from 'bootstrap-vue'

export default {
    components:{
        BFormRadio
    },
    props:{
        loading:Boolean,
        value:Object
    }
}
</script>

<style>

</style>